
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired293"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired293"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $17e566ead5312c11$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["6oMUc","index.8ef04f5b.js","3n0Kx","icons.7544671d.svg"]'));

const $9dfdde2870d5f6f9$export$923ea8233b386e99 = `https://forkify-api.herokuapp.com/api/v2/recipes`;
const $9dfdde2870d5f6f9$export$196440f71ed9f601 = 10;
const $9dfdde2870d5f6f9$export$d2f17d20365655cb = 16;
const $9dfdde2870d5f6f9$export$a9861bd62f48e142 = "";


let $f381a3c3b9cf5311$export$ca000e230c0caa3e = {
    search: {
        query: "",
        results: [],
        currPage: 1,
        resultsPerPage: (0, $9dfdde2870d5f6f9$export$d2f17d20365655cb)
    },
    recipe: {},
    bookmarks: []
};
function $f381a3c3b9cf5311$export$b57de12e37b07ee8() {
    localStorage.setItem("state", JSON.stringify($f381a3c3b9cf5311$export$ca000e230c0caa3e));
}
async function $f381a3c3b9cf5311$var$getJSON(url) {
    const res = await fetch(url);
    const data = await res.json();
    return data;
}
async function $f381a3c3b9cf5311$export$7e34e99eb2ee781b(searchTerm) {
    try {
        const results = await $f381a3c3b9cf5311$var$getJSON(`${(0, $9dfdde2870d5f6f9$export$923ea8233b386e99)}?search=${searchTerm}`);
        results.status;
        if (results.data.recipes.length < 1) throw new Error(`No results found for "${$f381a3c3b9cf5311$export$ca000e230c0caa3e.search.query}"`);
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.results = results.data.recipes.map((res)=>{
            return {
                publisher: res.publisher,
                imageUrl: res.image_url,
                title: res.title,
                id: res.id
            };
        });
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.query = searchTerm;
        $f381a3c3b9cf5311$export$b57de12e37b07ee8();
    } catch (error) {
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.results = [];
        throw error;
    }
}
async function $f381a3c3b9cf5311$export$d3bef8d36f4e0ca4(id) {
    try {
        const res = await $f381a3c3b9cf5311$var$getJSON(`${(0, $9dfdde2870d5f6f9$export$923ea8233b386e99)}/${id}`);
        res.status;
        const recipe = res.data.recipe;
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe = {
            publisher: recipe.publisher,
            ingredients: recipe.ingredients,
            sourceUrl: recipe.source_url,
            imageUrl: recipe.image_url,
            title: recipe.title,
            servings: recipe.servings,
            newServings: recipe.servings,
            cookingTime: recipe.cooking_time,
            id: recipe.id,
            bookmarked: false
        };
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.bookmarked = $f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks.some((bkm)=>bkm.id === $f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.id);
        $f381a3c3b9cf5311$export$b57de12e37b07ee8();
    } catch (error) {
        console.log(error);
    }
}
function $f381a3c3b9cf5311$export$2c1597c04af6df1b(query) {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.query = query;
    $f381a3c3b9cf5311$export$b57de12e37b07ee8();
}
function $f381a3c3b9cf5311$export$d3720feff416e85b() {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e = JSON.parse(localStorage.getItem("state"));
}
function $f381a3c3b9cf5311$export$ba2e7129f1af9511() {
    $f381a3c3b9cf5311$export$d3720feff416e85b();
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.results = [];
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.query = "";
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe = {};
    $f381a3c3b9cf5311$export$b57de12e37b07ee8();
}
function $f381a3c3b9cf5311$export$759efb64f013ba55(newPage) {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.currPage = newPage;
    $f381a3c3b9cf5311$export$b57de12e37b07ee8();
}
function $f381a3c3b9cf5311$export$af9c87babe194562(data) {
    const startIndex = ($f381a3c3b9cf5311$export$ca000e230c0caa3e.search.currPage - 1) * $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.resultsPerPage;
    const endIndex = startIndex + $f381a3c3b9cf5311$export$ca000e230c0caa3e.search.resultsPerPage;
    return data.slice(startIndex, endIndex);
}
function $f381a3c3b9cf5311$export$5e23f4642ecad5ea(newServings) {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.newServings = newServings;
}
function $f381a3c3b9cf5311$export$60ea320edcf8709a() {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.bookmarked = !$f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.bookmarked;
    if ($f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.bookmarked) $f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks.push($f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe);
    else if (!$f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.bookmarked) {
        const index = $f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks.findIndex((bkm)=>{
            return $f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe.id === bkm.id;
        });
        $f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    }
    $f381a3c3b9cf5311$export$b57de12e37b07ee8();
}


var $b68a436bede13655$exports = {};
$b68a436bede13655$exports = new URL("icons.7544671d.svg", import.meta.url).toString();


class $b14a471df14f0f7d$export$2e2bcd8739ae039 {
    _data;
    clearContainer() {
        this._parentEl.innerHTML = "";
    }
}


class $8937b2cdd89451ab$var$RecipeView extends (0, $b14a471df14f0f7d$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".recipe");
    renderRecipe(recipe) {
        this.clearContainer();
        const html = ` <h1 class="recipe__title heading heading-main-lrg">
    ${recipe.title}
  </h1>
  <div class="recipe__overview">
    <div class="recipe__detail">
      <svg class="recipe__detail-icon">
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}#time-outline"></use>
      </svg>
      <span class="recipe__detail-data recipe__detail-data--minutes"
        >${recipe.cookingTime}</span
      >
      <span class="recipe__detail-text">minutes</span>
    </div>
    <div class="recipe__detail">
      <svg class="recipe__detail-icon">
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}#person-sharp"></use>
      </svg>
      <span class="recipe__detail-data recipe__detail-data--servings"
        >${recipe.newServings}</span
      >
      <span class="recipe__detail-text">servings</span>
      <div class="recipe__detail-buttons">
        <button class="recipe__detail-btn recipe__detail-btn--plus" data-servings="${recipe.newServings + 1}">
          <svg class="recipe__detail-icon">
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}#add-circle"></use>
          </svg>
        </button>
        <button class="recipe__detail-btn recipe__detail-btn--minus" data-servings="${recipe.newServings - 1}">
          <svg class="recipe__detail-icon">
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}#minus-circle"></use>
          </svg>
        </button>
      </div>
    </div>
    <div class="recipe__bookmark-icon">
      <svg class="recipe__detail-icon">
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}#${recipe.bookmarked ? "bookmark" : "bookmark-outline"}"></use>
      </svg>
    </div>
  </div>
  <div class="recipe__image">
    <img
      src="${recipe.imageUrl}"
      alt="Recipe Image"
    />
  </div>
  <div class="ingredients">
    <h2 class="heading heading-sub ingredients__heading">
      Recipe Ingredients
    </h2>
    <ul class="ingredients__list">
    ${recipe.ingredients.map((ing)=>{
            return `<li class="ingredients__item">${ing.quantity ? ing.quantity / recipe.servings * recipe.newServings : ""} ${ing.unit} ${ing.description}</li>`;
        }).join("")}

    </ul>
  </div>
  <div class="instructions">
    <h2 class="heading heading-sub">Recipe Instructions</h2>
    <p class="instructions__text">
      This recipe was designed by
      <a href="${recipe.sourceUrl}" class="instructions__pub"
        >${recipe.publisher}</a
      >
      Please check out their website for instructions.
    </p>
  </div> `;
        this._parentEl.insertAdjacentHTML("afterbegin", html);
    }
    renderLoader() {
        this.clearContainer();
        const html = `<span class="loader"> </span>`;
        this._parentEl.insertAdjacentHTML("afterbegin", html);
    }
    addEventHandlerUpdateServings(handler) {
        this._parentEl.addEventListener("click", (e)=>{
            const btn = e.target.closest(".recipe__detail-btn");
            if (!btn) return;
            const newServings = +btn.dataset.servings;
            if (newServings < 1) return;
            handler(newServings);
        });
    }
    addEventHandlerAddBookmark(handler) {
        this._parentEl.addEventListener("click", (e)=>{
            const bookmarkToggle = e.target.closest(".recipe__bookmark-icon");
            if (!bookmarkToggle) return;
            handler();
        });
    }
    addEventListenerHashChange(handler) {
        window.addEventListener("hashchange", ()=>{
            handler(window.location.hash);
        });
    }
    addEventHandlerMarkIngredient() {
        this._parentEl.addEventListener("click", (e)=>{
            const ingred = e.target.closest(".ingredients__item");
            if (!ingred) return;
            ingred.classList.toggle("ingredients__item--checked");
        });
    }
}
var $8937b2cdd89451ab$export$2e2bcd8739ae039 = new $8937b2cdd89451ab$var$RecipeView();


class $64238f741e9088fb$var$SearchView {
    _parentEl = document.querySelectorAll(".search");
    getSearchQuery(e) {
        const query = e.target.firstElementChild.value;
        this._clearSearch(e);
        return query;
    }
    _clearSearch(e) {
        e.target.firstElementChild.value = "";
    }
    addEventHandlerSearch(handler) {
        this._parentEl.forEach((el)=>{
            el.querySelector(".search-form").addEventListener("submit", (e)=>{
                e.preventDefault();
                handler(e);
            });
        });
    }
}
var $64238f741e9088fb$export$2e2bcd8739ae039 = new $64238f741e9088fb$var$SearchView();




class $24517965e8aa0837$var$ResultsView extends (0, $b14a471df14f0f7d$export$2e2bcd8739ae039) {
    _resultsCont = document.querySelector(".results");
    _parentEl = document.querySelector(".results-container");
    renderSearchQuery(query) {
        this._resultsCont.querySelector(".results__search-query").innerText = `Results for ${query}:`;
    }
    renderResults(data) {
        if (data instanceof Error) {
            this._parentEl.insertAdjacentHTML("beforeend", `   <div class="upload-error">
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}#error"></use>
        </svg>
        <p class="upload-error__text">
         ${data}
        </p>
      </div>`);
            return;
        }
        data.forEach((res)=>{
            this._parentEl.insertAdjacentHTML("beforeend", `<a href="/recipe.html#${res.id}" class="results-container__card">
      <div class="results-container__card-img">
        <img
          src="${res.imageUrl}"
          alt="Recipe Image"
        />
      </div>
      <h3 class="results-container__card-name">
        ${res.title}
      </h3>
    </a>`);
        });
    }
    renderLoader() {
        const html = `<span class="placeholder"> </span>`;
        for(let i = 0; i < 8; i++)this._parentEl.insertAdjacentHTML("afterbegin", html);
    }
}
var $24517965e8aa0837$export$2e2bcd8739ae039 = new $24517965e8aa0837$var$ResultsView();



class $06cbd48407ebdfc3$var$PaginationView extends (0, $b14a471df14f0f7d$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".pagination");
    addHandlerPagination(handler) {
        this._parentEl.addEventListener("click", (e)=>{
            if (!e.target.classList.contains("pagination__item")) return;
            const currentPage = +e.target.innerText;
            handler(currentPage);
        });
    }
    renderPagination(data) {
        this.clearContainer();
        const resPerPage = data.search.resultsPerPage;
        const noPages = data.search.results.length / resPerPage;
        for(let i = 0; i < noPages; i++)this._parentEl.insertAdjacentHTML("beforeend", `<a class="pagination__item ${data.search.currPage === i + 1 ? "active" : ""}" href="#">${i + 1}</a>`);
    }
}
var $06cbd48407ebdfc3$export$2e2bcd8739ae039 = new $06cbd48407ebdfc3$var$PaginationView();




class $f6606503c67d929a$var$bookmarksView extends (0, $b14a471df14f0f7d$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".bookmarks__content");
    renderBookmarks(bookmarks) {
        this.clearContainer();
        if (bookmarks.length < 1) this._parentEl.insertAdjacentHTML("beforeend", ` <div class="bookmarks__error">
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}.svg#error"></use>
        </svg>
        <p class="bookmarks__error-text">
          You have no bookmarks yet to display!
        </p>
      </div>
      `);
        bookmarks.forEach((bkm)=>{
            this._parentEl.insertAdjacentHTML("beforeend", `<a href="/recipe.html#${bkm.id}">
    <div class="bookmarks__item">
    <div class="bookmarks__img">
      <img src="${bkm.imageUrl}" alt="" />
    </div>
    <div class="bookmarks__text">
      <p class="bookmarks__title">${bkm.title}</p>
      <p class="bookmarks__pub">${bkm.publisher}</p>
    </div>
    <svg class="bookmarks__delete-icon">
      <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($b68a436bede13655$exports)))}#delete"></use>
    </svg>
  </div></a>`);
        });
    }
}
var $f6606503c67d929a$export$2e2bcd8739ae039 = new $f6606503c67d929a$var$bookmarksView();




class $89190104e3af449c$var$addRecipeView extends (0, $b14a471df14f0f7d$export$2e2bcd8739ae039) {
}
var $89190104e3af449c$export$2e2bcd8739ae039 = new $89190104e3af449c$var$addRecipeView();


async function $03cf872f16b5d10b$var$newSearch(e) {
    const query = (0, $64238f741e9088fb$export$2e2bcd8739ae039).getSearchQuery(e);
    if (!query) return;
    $f381a3c3b9cf5311$export$2c1597c04af6df1b(query);
    window.location.href = `/results.html`;
}
function $03cf872f16b5d10b$var$renderPageResults(data, page = 1) {
    (0, $24517965e8aa0837$export$2e2bcd8739ae039).renderSearchQuery(data.query);
    (0, $24517965e8aa0837$export$2e2bcd8739ae039).clearContainer();
    $f381a3c3b9cf5311$export$759efb64f013ba55(page);
    (0, $24517965e8aa0837$export$2e2bcd8739ae039).renderResults($f381a3c3b9cf5311$export$af9c87babe194562(data.results));
    (0, $06cbd48407ebdfc3$export$2e2bcd8739ae039).renderPagination($f381a3c3b9cf5311$export$ca000e230c0caa3e);
}
function $03cf872f16b5d10b$var$newPage(page) {
    $03cf872f16b5d10b$var$renderPageResults($f381a3c3b9cf5311$export$ca000e230c0caa3e.search, page);
}
async function $03cf872f16b5d10b$var$renderRecipe(hash) {
    const id = hash.substring(1);
    (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).renderLoader();
    await $f381a3c3b9cf5311$export$d3bef8d36f4e0ca4(id);
    (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).renderRecipe($f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe);
}
function $03cf872f16b5d10b$var$controlServings(newServings) {
    $f381a3c3b9cf5311$export$5e23f4642ecad5ea(newServings);
    (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).renderRecipe($f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe);
}
function $03cf872f16b5d10b$var$controlBookmarks() {
    $f381a3c3b9cf5311$export$60ea320edcf8709a();
    (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).renderRecipe($f381a3c3b9cf5311$export$ca000e230c0caa3e.recipe);
    (0, $f6606503c67d929a$export$2e2bcd8739ae039).renderBookmarks($f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks);
}
async function $03cf872f16b5d10b$var$init() {
    switch(window.location.pathname){
        case "/":
        case "/index.html":
            if (localStorage.getItem("state") == null) $f381a3c3b9cf5311$export$b57de12e37b07ee8();
            $f381a3c3b9cf5311$export$ba2e7129f1af9511();
            (0, $f6606503c67d929a$export$2e2bcd8739ae039).renderBookmarks($f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks);
            break;
        case "/results.html":
            try {
                $f381a3c3b9cf5311$export$d3720feff416e85b();
                (0, $f6606503c67d929a$export$2e2bcd8739ae039).renderBookmarks($f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks);
                (0, $24517965e8aa0837$export$2e2bcd8739ae039).renderLoader();
                await $f381a3c3b9cf5311$export$7e34e99eb2ee781b($f381a3c3b9cf5311$export$ca000e230c0caa3e.search.query);
                $03cf872f16b5d10b$var$renderPageResults($f381a3c3b9cf5311$export$ca000e230c0caa3e.search);
                (0, $06cbd48407ebdfc3$export$2e2bcd8739ae039).addHandlerPagination($03cf872f16b5d10b$var$newPage);
            } catch (error) {
                (0, $24517965e8aa0837$export$2e2bcd8739ae039).clearContainer();
                (0, $24517965e8aa0837$export$2e2bcd8739ae039).renderResults(error);
                console.error(error);
            }
            break;
        case "/recipe.html":
            $f381a3c3b9cf5311$export$d3720feff416e85b();
            (0, $f6606503c67d929a$export$2e2bcd8739ae039).renderBookmarks($f381a3c3b9cf5311$export$ca000e230c0caa3e.bookmarks);
            (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).addEventListenerHashChange($03cf872f16b5d10b$var$renderRecipe);
            $03cf872f16b5d10b$var$renderRecipe(window.location.hash);
            (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).addEventHandlerUpdateServings($03cf872f16b5d10b$var$controlServings);
            (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).addEventHandlerAddBookmark($03cf872f16b5d10b$var$controlBookmarks);
            (0, $8937b2cdd89451ab$export$2e2bcd8739ae039).addEventHandlerMarkIngredient();
            break;
    }
    (0, $64238f741e9088fb$export$2e2bcd8739ae039).addEventHandlerSearch($03cf872f16b5d10b$var$newSearch);
}
$03cf872f16b5d10b$var$init();


//# sourceMappingURL=index.8ef04f5b.js.map
